export enum LocalStorageKey {
  AuthInfo = "AUTH_INFO",
  PendingRedirectPath = "PENDING_REDIRECT_PATH",
  UpgradedUserEmail = "UPGRADED_USER_EMAIL",
  StripeLastCheckoutSession = "STRIPE_LAST_CHECKOUT_SESSION",
  ThemeType = "THEME_TYPE",
}
